export default "__VITE_ASSET__vWY4SZJ0__"